export default class WriteReview {
	init() {
		const setupStars = () => {
			let starsFields = document.querySelectorAll('.starsField:not(.fieldConfigured)');

			for (let s = 0; s < starsFields.length; s++) {
				const starsField = starsFields[s];
				starsField.classList.add('fieldConfigured');

				const dropdown = starsField.querySelector('select') as HTMLSelectElement;
				let currentValue = parseInt(dropdown.value);
				if (isNaN(currentValue)) {
					currentValue = null;
				}

				/*
				----------
				NOTE:  Removed because progressive enhancement is not an allowed option for A11Y certification
				----------
				const stars = starsField.querySelectorAll('.starsField g');
				for (let i = 0; i < stars.length; i++) {
					let star = stars[i];
					// console.log(i+" < "+currentValue);
					if (currentValue !== null && i < currentValue) {
						star.setAttribute('data-active', 'true');
					}

					star.addEventListener('mouseenter', (event: Event) => {
						const hoveredStar = event.currentTarget;

						let isActive = true;

						// Loop through stars and fill them in appropriately
						for (let i = 0; i < stars.length; i++) {
							const star = stars[i];
							if (isActive) {
								star.setAttribute('data-hover', 'true');

								if (star === hoveredStar) {
									isActive = false;
								}
							} else {
								star.removeAttribute('data-hover');
							}
						}
					}, false);

					star.addEventListener('mouseleave', (event: Event) => {
						for (let i = 0; i < stars.length; i++) {
							const star = stars[i];
							if (star.getAttribute('data-hover') == 'true') {
								star.removeAttribute('data-hover');
							}
						}
					}, false);

					star.addEventListener('click', (event: Event) => {
						const clickedStar = event.currentTarget;

						let isActive = true;
						let newStarValue = 0;

						// Loop through stars and fill them in appropriately
						// Also find clicked star's index
						for (let i = 0; i < stars.length; i++) {
							const star = stars[i];
							if (isActive) {
								star.setAttribute('data-active', 'true');

								if (star === clickedStar) {
									isActive = false;
									newStarValue = i + 1;
								}
							} else {
								star.removeAttribute('data-active');
							}
						}

						// Set the value of the dropdown
						dropdown.value = newStarValue.toString();
						addSelectedAttribute();
						dropdown.dispatchEvent(new Event('change'));
					}, false);
				}
				*/


				const doNotRateButton = starsField.querySelector('.starsField__doNotRateButton');

				if (doNotRateButton != null) {
					if (dropdown.value === '') {
						starsField.setAttribute('data-rated', 'false');
						doNotRateButton.textContent = 'Undo';
					} else {
						starsField.setAttribute('data-rated', 'true');
					}

					doNotRateButton.addEventListener('click', (event: Event) => {
						event.preventDefault();

						if (starsField.getAttribute('data-rated') === 'false') {
							starsField.setAttribute('data-rated', 'true');
							doNotRateButton.textContent = 'Do Not Rate';
							dropdown.value = '0';
						} else {
							starsField.setAttribute('data-rated', 'false');
							doNotRateButton.textContent = 'Undo';
							dropdown.value = '';
						}

						addSelectedAttribute();
					}, false);
				}

				const addSelectedAttribute = () => {
					const dropdownOptions = dropdown.querySelectorAll('option');
					for (let i = 0; i < dropdownOptions.length; i++) {
						dropdownOptions[i].removeAttribute('selected');

						if (dropdownOptions[i].value == dropdown.value) {
							dropdownOptions[i].setAttribute('selected', 'selected');
						}
					}
				}
			}
		};

		setupStars();
		document.addEventListener('jsfAjaxEvent', (event) => {
			if ((event as any).detail.fireType === 'always') {
				setupStars();
			}
		});
	}
}

